import React, { useEffect } from 'react';
import { MarketplaceOpportunity } from '../../../../../slices/marketplace/opportunity/models/opportunity';
import SellerProfileWrapper from '../../../../../components/MarketplaceSellerProfile/SellerProfileWrapper/SellerProfileWrapper';
import { useStateSelector } from '../../../../../store/selectors';
import { MarketplaceSellerProfile } from '../../../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import './SellerProfileTab.scss';
import { useDispatch } from 'react-redux';
import { ViewSellerProfile } from '../../../../../slices/marketplace/opportunity/thunks/view-seller-profile.thunk';

interface SellerProfileTabProps {
    opportunity: MarketplaceOpportunity;
}

const SellerProfileTab: React.FC<SellerProfileTabProps> = ({ opportunity }) => {
    const isIdNdaSigned = opportunity.isIdNdaSigned;
    const dispatch = useDispatch() as any;
    const sellerProfile = useStateSelector(
        (state) => state.profilesData.selectedPofile
    ) as MarketplaceSellerProfile;
    const selectedOpportunity = useStateSelector(
        (state) => state.opportunities.selectedOpportuity
    );
    useEffect(() => {
        if (
            isIdNdaSigned &&
            selectedOpportunity &&
            !selectedOpportunity.buyer.hasViewedSellerProfile
        ) {
            dispatch(ViewSellerProfile(opportunity.opportunityId));
        }
    }, []);

    return (
        <div className="seller-profile-tab">
            <SellerProfileWrapper
                isDisclosed={isIdNdaSigned}
                profileData={sellerProfile}
            />
        </div>
    );
};

export default SellerProfileTab;
